module.exports = __webpack_public_path__ + "img/avatar.fbc3a34b.png";